export default "__VITE_ASSET__DLSqaNrc__"